import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./utils";
export var Tag = function (_a) {
    var children = _a.children, className = _a.className;
    return (_jsx("div", { className: cn("text-xs text-accent font-medium bg-card rounded px-2 py-0.5 flex items-center", className), children: children }));
};
